import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)


/*
 * Smooth scroll
 */

// 固定ヘッダー（固定しない場合は = 0）
// const headerHeight = document.querySelector('header').offsetHeight + 0;
const headerHeight = 0;

// イージング関数（easeOutExpo）
function scrollToPos(position) {
  const startPos = window.scrollY;
  const distance = Math.min(position - startPos, document.documentElement.scrollHeight - window.innerHeight - startPos);
  const duration = 800; // スクロールにかかる時間（ミリ秒）

  let startTime;

  function easeOutExpo(t, b, c, d) {
    return c * (-Math.pow(2, -10 * t / d) + 1) * 1024 / 1023 + b;
  }

  function animation(currentTime) {
    if (startTime === undefined) {
      startTime = currentTime;
    }
    const timeElapsed = currentTime - startTime;
    const scrollPos = easeOutExpo(timeElapsed, startPos, distance, duration);
    window.scrollTo(0, scrollPos);
    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    } else {
      window.scrollTo(0, position);
    }
  }

  requestAnimationFrame(animation);
}

// 遅延読み込み解除
function removeLazyLoad() {
  const targets = document.querySelectorAll('[data-src]');
  for (const target of targets) {
    target.setAttribute('src', target.getAttribute('data-src'));
    target.addEventListener('load', () => {
      target.removeAttribute('data-src');
    });
  }
}

// ページ内のスムーススクロール
for (const link of document.querySelectorAll('a[href*="#"]')) {
  link.addEventListener('click', (e) => {
    const hash = e.currentTarget.hash;
    const target = document.getElementById(hash.slice(1));

    // ページトップへ("#"と"#top"）
    if (!hash || hash === '#top') {
      e.preventDefault();
      scrollToPos(1); // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に

    // アンカーへ
    } else if (target) {
      e.preventDefault();
      removeLazyLoad();
      const position = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      scrollToPos(position);

      // URLにハッシュを含める
      history.pushState(null, '', hash);
    }
  });
};

// 別ページ遷移後のスムーススクロール
const urlHash = window.location.hash;
if (urlHash) {
  const target = document.getElementById(urlHash.slice(1));
  if (target) {
    // ページトップから開始（ブラウザ差異を考慮して併用）
    history.replaceState(null, '', window.location.pathname);
    window.scrollTo(0, 0);

    removeLazyLoad();
    window.addEventListener("load", () => {
      const position = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      scrollToPos(position);

      // ハッシュを再設定
      history.replaceState(null, '', window.location.pathname + urlHash);
    });
  }
}



$(".opensub").click(function(){
  window.open(this.href,"WindowName","width=520,height=520,resizable=yes,scrollbars=yes");
  return false;
});



/*
 * IntersectionObserver
 */
document.addEventListener('DOMContentLoaded', function () {
  // Top page
  const scroll = new ScrollShow('.obs');

  // youtube
  // Code: <iframe class="youtube-lazyload" src="data:Now%2C%20Loading..." data-src="https://www.youtube.com/embed/************" width="560" height="315" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  const youtube = new ScrollShow('.youtube-lazyload', (entries, observer) => {
    entries.forEach((el) => {
      if(el.isIntersecting){
        el.target.src = el.target.dataset.src;
        observer.unobserve(el.target);
      }
    });
  });
});

class ScrollShow {
  constructor(el, callback, options) {
    this._addOptions(options);
    this._addCallback(callback);
    const observer = new IntersectionObserver(this.callback, this.options);
    const els = document.querySelectorAll(el);
    els.forEach( el => observer.observe(el));
  }

  _addOptions(options) {
    this.options = Object.assign({
      root: null,
      rootMargin: "0px",
      threshold: 0
    }, options);
  }
  _addCallback(callback) {
    if (callback) {
      this.callback = callback;
    } else {
      this.callback = (entries, observer) => {
        entries.forEach( entry => {
          if(entry.isIntersecting) {
            entry.target.classList.add('--in');
            observer.unobserve(entry.target);
          } else {
            entry.target.classList.remove('--in');
          }
        });
      };
    }
  }
}
